import gql from 'graphql-tag';
import fragments from '../fragments.js';

export default {
    updatePostMutation: gql`
        mutation UpdatePost($postId: String!, $caption: String, $image: ImageInput, $link: LinkInput, $removeLink: Boolean, $status: ResourceStatus, $externalID: String, $bookmarked: Boolean, $contributorName: String) {
            updatePost(postID: $postId, post: { caption: $caption, image: $image, link: $link, removeLink: $removeLink, status: $status, externalID: $externalID, bookmarked: $bookmarked, contributorName: $contributorName }) {
                ...PostWithSensitiveDataFragment
                ...PostWithSensitiveDataFullTranscriptsFragment
            }
        }

        ${fragments.postWithSensitiveData}
        ${fragments.image}
        ${fragments.audio}
        ${fragments.postWithSensitiveDataFullTranscripts}
    `,
};
